<template>
  <div v-if="isAdmin">
    <h3>{{$t('launch.tab.control.heading.add_categories')}}</h3>

    <el-select
      v-model="categories"
      multiple
      filterable
      placeholder="Select categories"
    >
      <el-option
        v-for="op in options"
        :key="op.id"
        :label="op.label"
        :value="op.id"
      />
    </el-select>
  </div>
</template>

<script>
import * as getters from '../../../../store/modules/getters'
import * as actions from '../../../../store/modules/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Categories',
  data () {
    return {
      options: [
        { id: 'app_downloads', label: this.$t('element.properties.app_downloads.label') },
        { id: 'ebook', label: this.$t('marketplace.sidebar.filter.ebook') },
        { id: 'e-commerce', label: this.$t('element.properties.ecommerce.label') },
        { id: 'lead_gen', label: this.$t('marketplace.sidebar.filter.leadgen') },
        { id: 'pre_orders', label: this.$t('element.properties.preorders.label') },
        { id: 'promote_new_product', label: this.$t('element.properties.promote_a_new_product.label') },
        { id: 'other', label: this.$t('element.properties.other.label') },
        { id: 'webinar', label: this.$t('marketplace.sidebar.filter.webinar') },
        { id: 'doi', label: this.$t('element.properties.doi.label') },
        { id: 'events', label: this.$t('element.properties.events.label') },
        { id: 'sales_page', label: this.$t('element.properties.sales_page.label') },
        { id: 'newsletter_signup', label: this.$t('element.properties.news_letter_and_sign_up.label') },
        { id: 'free_resources_downloads', label: this.$t('element.properties.free_resources_downloads.label') },
        { id: 'video_pages', label: this.$t('element.properties.video_pages.label') },
        { id: 'about', label: this.$t('element.properties.about.label') },
        { id: 'offer_discount_coupon', label: this.$t('element.properties.offer_discounts_and_coupon.label') },
        { id: 'real_estate', label: this.$t('element.properties.real_estate.label') },
        { id: 'customer_success', label: this.$t('element.properties.customer_success.label') },
        { id: 'b2b', label: 'B2B' },
        { id: 'marketing', label: this.$t('marketplace.sidebar.filter.marketing')},
        { id: 'product_generic', label: this.$t('marketplace.sidebar.filter.product')},
        { id: 'sales_generic', label: this.$t('marketplace.sidebar.filter.sales')}
      ],
      categories: []
    }
  },
  computed: {
    ...mapGetters({
      site: getters.SITE_GET_DATA,
      isAdmin: getters.AUTH_GET_USER_IS_ADMIN
    })
  },
  watch: {
    categories (n) {
      this.updateCategories({
        id: this.site.id,
        categories: n.map(id => ({ id }))
      })
    }
  },
  mounted () {
    this.mapCategories()
  },
  methods: {
    ...mapActions({
      updateCategories: actions.SITE_UPDATE_CATEGORIES
    }),
    mapCategories () {
      this.categories = this.site.categories.map(c => c.id)
    }
  }
}
</script>

<style lang="scss">
</style>
